module.exports = __webpack_public_path__ + "static/media/GH03.04b5be0c.png";